import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { validateAffiliateLink, getAffiliateCodeFromLink, AFFILIATE_LINK_PARAMS } from '../helpers/validate';
import { accountSelector, isAuthSelector } from '../data/selectors/user';

export const useAffiliate = () => {
  const link = window.location.href;
  const isAuth = useSelector(isAuthSelector);
  const { emailVerified } = useSelector(accountSelector);

  useEffect(() => {
    if ((!isAuth || !localStorage.getItem('affiliate')) && validateAffiliateLink(link)) {
      try {
        const url = new URL(link);
        const params = new URLSearchParams(url.search);
        const affiliateCode = getAffiliateCodeFromLink(link);
        if (affiliateCode) {
          localStorage.setItem('affiliate', affiliateCode);

          // Strip every referral param, not just the one that matched, so a link carrying both
          // cannot leave the loser behind in the address bar and get re-read on a later visit.
          AFFILIATE_LINK_PARAMS.forEach((name) => params.delete(name));
          const newSearch = params.toString();
          const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ''}${url.hash}`;
          window.history.replaceState({}, '', newUrl);
        }
      } catch (error) {
        console.warn('Failed to parse affiliate link:', error);
      }
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!!localStorage.getItem('affiliate') && emailVerified) {
      localStorage.removeItem('affiliate');
    }
  }, [emailVerified]);
};
